<template>
  <div class="create-container">
    <div style="margin-bottom: 20px">
      <!--返回临时工账号列表-->
      <el-button
        icon="el-icon-back" size="small" plain
        @click="closeWindow(false)"
      >{{ $t('userManage.ReturnListTemporaryWorkerAccounts') }}</el-button>
    </div>
    <div style="margin-bottom: 20px;">
      <!--重新申请临时工账号-->
      <div class="create-title">{{ $t('userManage.ReapplyTemporaryWorkerAccount') }}</div>
      <!--账号已到期，需要重新申请新的有效期后才能继续登录-->
      <div style="font-size: 14px">{{ $t('userManage.AccountHasExpired') }}</div>
    </div>
    <div class="reapply-container">
      <div class="reapply-title-con">
        <div class="reapply-title">{{ $t('userManage.ReapplyForAnAccount') }}</div>
        <div style="font-size: 14px">{{ $t('userManage.TheBasicPersonnelInformation') }}</div>
      </div>
      <div style="padding: 20px">
        <div class="reapply-warning-tips">
          {{ $t('userManage.TheOriginalAccount') }}
          <span style="font-weight: bold">{{ formData.username }}</span>
          {{ $t('userManage.hasExpired') }}
          <span style="font-weight: bold">{{ formData.expireAt }}</span>
          {{ $t('userManage.AfterTheReapplicationIsApproved') }}
        </div>
        <div class="rest-form">
          <el-form ref="formDataRef" :model="formData" label-position="top">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('collectionCenter.compellation')">
                  <el-input v-model="formData.realName" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="CPF">
                  <el-input v-model="formData.cpf" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('collectionCenter.val13')">
                  <el-input v-model="formData.siteName" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('home.position')">
                  <el-input v-model="formData.positionName" clearable />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  :label="$t('userManage.NumberOfDaysTheAccountIsValid')"
                  prop="validDays"
                  :rules="[
                    { required: true, message: $t('userManage.notNull'), trigger: ['change', 'blur'] },
                    { validator: checkNumber, trigger: ['change', 'blur'] }
                  ]"
                >
                  <el-input v-model="formData.validDays" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('userManage.NumberOfDaysTheAccountIsValid')">
                  <el-input v-model="formData.rules" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item :label="$t('userManage.ReasonForApplication')">
                  <el-input
                    v-model="formData.reason" :rows="3" maxlength="200"
                    show-word-limit
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="reapply-rules">
          <span style="font-weight: bold">{{ $t('userManage.ReapplyRules') }}：</span>
          {{ $t('userManage.ReapplyRuleDescription') }}
        </div>
      </div>
      <div style="padding: 20px;border-top: 1px solid #ddd;">
        <el-button plain @click="closeWindow(false)">{{ $t('userManage.cancel') }}</el-button>
        <el-button type="primary" style="float: right" @click="submitANewApplication">{{ $t('userManage.SubmitANewApplication') }}</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { getFreelancerDetailApi, getFreelancerStatusApi } from '@/api/user';

export default {
  name: 'ReapplyAccount',
  props: {
    accountDetail: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    const checkNumber = (rule, value, callback) => {
      const reg = /^\d+$/;
      if (!reg.test(value)) {
        return callback(new Error(this.$t('mdfeTranslate.OnlyNumbersCanBeEntered')));
      } else {
        return callback();
      }
    };
    return {
      formData: {
        realName: null,
        cpf: null,
        siteName: null,
        positionName: null,
        validDays: null,
        rules: null,
        reason: null
      },
      checkNumber
    };
  },
  created() {
    this.getDetailData();
  },
  methods: {
    // 查询详情
    getDetailData() {
      getFreelancerDetailApi(this.accountDetail.id).then(res => {
        if (res.code === 200) {
          this.formData = {
            ...res.data,
            validDays: 7,
            rules: this.$t('userManage.EffectiveImmediately'),
            reason: this.$t('userManage.ContinueTempUnloadWork')
          };
        }
      });
    },
    // 返回列表
    closeWindow(data) {
      this.$emit('closeWindow', data);
    },
    // 提交申请
    submitANewApplication() {
      this.$refs.formDataRef.validate(valid => {
        if (valid) {
          const param = {
            id: this.accountDetail.id,
            validDays: this.formData.validDays,
            positionName: this.formData.positionName,
            reason: this.formData.reason,
            type: 1
          };
          getFreelancerStatusApi(param).then(res => {
            if (res.code === 200) {
              this.$message.success(this.$t('userManage.TheReapplicationHasBeenSubmitted') + this.formData.validDays + this.$t('userManage.days'));
              this.$emit('closeWindow', true);
            }
          });
        }
      });
    }
  }
};
</script>

<style  scoped>
.create-container {
  background:#f5f7f9;
  padding: 20px;
  min-height: 100%;
}
.create-title {
  font-size: 20px;
  font-weight: bold;
  color:#000;
}
.reapply-container {
  border: 1px solid #ddd;
  border-radius: 10px;
  background:#fff;
}
.reapply-title-con {
  padding: 20px;
  border-bottom: 1px solid #ddd;
}
.reapply-title {
  font-size: 17px;
  font-weight: bold;color: #000;
}
.reapply-warning-tips {
  border: 1px solid #f6caca;
  background:#fef2f2;
  padding: 15px;
  border-radius: 10px;
  color:#9b1c1c;
  font-size: 14px;
  margin-bottom: 20px;
}
.reapply-rules {
  border: 1px solid #ddd;
  border-radius: 10px;
  background:#f4f8fc;
  padding: 10px;
  font-size: 14px;
}
::v-deep .rest-form .el-input__inner {
  color: #6e6e6e;
}
</style>
